import {
  alertVariants,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { Share2 as ShareIcon } from "lucide-react";
import { string } from "prop-types";
import { useDispatch } from "react-redux";
import { showGlobalAlert } from "slices/app/appSlice";

import styles from "./ShareUrlButton.module.scss";

const ShareUrlButton = ({ url }) => {
  const dispatch = useDispatch();

  const onShare = async () => {
    try {
      await navigator.clipboard.writeText(url ?? window.location.href);
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: "Link copied to clipboard",
        })
      );
    } catch {
      dispatch(
        showGlobalAlert({
          variant: alertVariants.danger,
          text: "Could not copy the link. Please try again.",
        })
      );
    }
  };

  return (
    <NewButton
      variant={NewButtonVariant.l2}
      aria-label="Share URL"
      className={styles.share_url_button}
      onClick={onShare}
    >
      <ShareIcon size={16} />
    </NewButton>
  );
};

ShareUrlButton.propTypes = {
  url: string,
};

export default ShareUrlButton;
